export default "__VITE_ASSET__65b1a840__"